import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { type ActionQueryScope } from "../ActionService";

/**
 * The distinct tags on the actions in `scope`, sorted: the vocabulary a Tags
 * filter offers. Read from the tags endpoints rather than folded from a
 * listing, so the list page never has to fetch every action to build a menu.
 */
export function useActionTags(scope: ActionQueryScope) {
  const { actionService } = useDomainServices();
  const { currentOrganization } = useAuth();

  return useQuery<string[], Error>({
    queryKey: ["actions", "tags", scope, currentOrganization?.org_id],
    queryFn({ signal }) {
      if (currentOrganization === null) {
        return Promise.reject(new Error("Requires login"));
      }

      return actionService.listTags(scope, {
        abortSignal: signal,
        orgId: currentOrganization.org_id,
      });
    },
    enabled: currentOrganization !== null,
    staleTime: 30_000,
  });
}
